import './styles/main.css';

import { launch } from './launch';

interface HotNodeModule extends NodeModule {
    hot?: {
        accept: (path?: string, callback?: () => void) => void;
    };
}

if ((module as HotNodeModule).hot) {
    (module as HotNodeModule).hot?.accept();
}

void launch(window);
